import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logBookService } from "../services/lessonService";
import { defaultEntityAdapter } from "./utils";

export const getStudentLogBook = createAsyncThunk(
    "studentLogBook/get",
    async ids => await Promise.all(
        ids.map(student_id => logBookService.getStudentLogBook({ student_id }).then(res => ({ logBook: res.data, id: student_id })))
    )
)

const logBookSlice = createSlice({
    name: "studentLogBook",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null,
    }),
    reducers: {
        resetStudentLogBook: state => { defaultEntityAdapter.removeAll(state) }
    },
    extraReducers: builder => {
        builder
            .addCase(getStudentLogBook.pending, state => { state.isLoading = true })
            .addCase(getStudentLogBook.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getStudentLogBook.rejected, (state, action) => {
                state.error = action.error
                state.isLoading = false
            })
    }
})

export default logBookSlice.reducer

export const { resetStudentLogBook } = logBookSlice.actions

export const studentLogBookSelectors = defaultEntityAdapter.getSelectors(x => x.studentLogBook)

export const useStudentLogBook = students => {

    const dispatch = useDispatch()

    React.useEffect(() => {
        if (students && students?.length > 0) {
            dispatch(getStudentLogBook(students.map(el => el.id)))
        }
        return () => dispatch(resetStudentLogBook())
    }, [dispatch, students])

    const studentLogBook = useSelector(studentLogBookSelectors.selectAll)
    const studentLogBookIsLoading = useSelector(x => x.studentLogBook.isLoading)


    return { studentLogBook, studentLogBookIsLoading }
}